import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import Config from '../../../helpers/Config';
import SiteBreadcrumb from '../../components/layout/SiteBreadcrumb';
import { Media, Row, Col, Container } from "reactstrap";
import aboutImg from '../../../resources/custom/images/about-us.jpg';
import CustomerTestimonial from '../../components/shared/CustomerTestimonial';
import './our-team.css';
import { useDispatch } from 'react-redux';
import { MakeApiCallAsync } from '../../../helpers/ApiHelpers';
import rootAction from '../../../stateManagment/actions/rootAction';
import { LOADER_DURATION } from '../../../helpers/Constants';
import { getLanguageCodeFromSession } from '../../../helpers/CommonHelper';
import { Modal, ModalBody } from 'reactstrap';

let errorImageUrl = Config['ADMIN_BASE_URL'] + "/content/themeContent/global_assets/images/placeholders/placeholder.jpg"; 

const OurTeam = () => {
  const dispatch = useDispatch();
  const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);
  const [adminPanelBaseURL, setBaseUrl] = useState(Config['ADMIN_BASE_URL']);
  const [TeamsList, setTeamsList] = useState([]);
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [modalImageSrc, setModalImageSrc] = useState('');
  const [modalImageAlt, setModalImageAlt] = useState('');

  const getAllTeams = async () => {
    try {
      dispatch(rootAction.commonAction.setLoading(true));

      let headersFromPage = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      }

      let paramFromPage = {
        requestParameters: {
            SearchTerm: "",
        },
      };

      let response = await MakeApiCallAsync(Config.END_POINT_NAMES['GET_All_TEAMS'], null, paramFromPage, headersFromPage, "POST", true);
      if (response != null && response.data != null) {
        // response.data.data might be a JSON string or object depending on API
        let data = response.data.data;
        try {
          if (typeof data === 'string') data = JSON.parse(data);
        } catch (e) {
          // ignore parse error
        }
        // expecting { success:true, result: [...] }
        if (data && data.result) {
          setTeamsList(data.result);
        } else if (Array.isArray(data)) {
          setTeamsList(data);
        }
      }

      setTimeout(() => {
        dispatch(rootAction.commonAction.setLoading(false));
      }, LOADER_DURATION);
    } catch (error) {
      setTimeout(() => {
        dispatch(rootAction.commonAction.setLoading(false));
      }, LOADER_DURATION);
    }
  }

  useEffect(() => {
    getAllTeams();
  }, []);

  const openImageModal = (src, alt) => {
    setModalImageSrc(src);
    setModalImageAlt(alt || '');
    setImageModalOpen(true);
  }

  const closeImageModal = () => {
    setModalImageSrc('');
    setModalImageAlt('');
    setImageModalOpen(false);
  }

  const sanitizeHtml = (html) => {
    if (!html) return '';
    // remove script tags
    let sanitized = html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');
    // remove on* attributes (onclick, onerror, etc.)
    sanitized = sanitized.replace(/on\w+=["'][\s\S]*?["']/gi, '');
    return sanitized;
  }

  return (
    <>

      <Helmet>
        <title>{siteTitle} - Our Team</title>
        <meta name="description" content={siteTitle + " - Our Team page"}  />
        <meta name="keywords" content="Our Team, Team"></meta>
      </Helmet>

      <SiteBreadcrumb title="Our Team" parent="Home"/>

      <section className="about-page section-big-py-space">
        <div className="custom-container">
          <Row>
            <Col lg="12">
              <h4>Meet Our Team</h4>
              <p className="mb-2">
                Welcome to <b>Oriental Exotic SPRL Foods</b>. Our team is made up of passionate professionals committed to bringing you the best products and service.
              </p>
              <Row className="mt-4">
                {!TeamsList || TeamsList.length === 0 ? (
                  <Col xs="12">
                    <div className="text-center">No team members found.</div>
                  </Col>
                ) : (
                  TeamsList.map((member, idx) => (
                      <Col lg="12" key={idx} className="mb-4">
                        <div className="team-card row-layout p-3 border">
                          <div style={{flex:'0 0 auto',maxWidth:220}}>
                            <img
                              src={adminPanelBaseURL + (member.PhotoURL || member.PhotoUrl || '')}
                              alt={member.MemberName || member.memberName}
                              className="team-avatar"
                              onError={(e) => { e.target.src = errorImageUrl }}
                              style={{cursor:'pointer'}}
                              onClick={(e) => { e.preventDefault(); openImageModal(adminPanelBaseURL + (member.PhotoURL || member.PhotoUrl || ''), member.MemberName || member.memberName); }}
                            />
                          </div>
                          <div className="team-content">
                            <a className="team-link" >
                              <h6 className="team-name">{member.MemberName || member.memberName || member.Name}</h6>
                              {member.Title ? <div className="team-title">{member.Title}</div> : null}
                            </a>
                            {member.Message ? (
                              <div className="team-message text-left mt-2" dangerouslySetInnerHTML={{__html: sanitizeHtml(member.Message)}} />
                            ) : null}
                          </div>
                        </div>
                      </Col>
                    ))
                )}
              </Row>
            </Col>
          </Row>
        </div>
      </section>

      {/* <CustomerTestimonial /> */}

      <Modal isOpen={imageModalOpen} toggle={closeImageModal} centered size="lg" keyboard>
        <ModalBody>
          <button type="button" className="close btn" onClick={closeImageModal} aria-label="Close">×</button>
          <img
            src={modalImageSrc || errorImageUrl}
            alt={modalImageAlt}
            className="team-modal-img"
            onError={(e) => { e.target.src = errorImageUrl }}
          />
        </ModalBody>
      </Modal>

    </>
  );

}

export default OurTeam;
